(ns frontend.view.components.timeline.entry.oppo-reactivate
  (:require [frontend.view.components.timeline.entry.declaration :as te]
            [frontend.view.components.timeline.entry.default-item :as default]
            [frontend.view.components.timeline.db :as db]
            [common.localization :as loc]
            [clojure.string :as string]
            [frontend.state.current-session :as session]))

(defn title-generator [entry]
  (->> entry
       :audit/target
       (get @session/entities)
       :oppo/name
       vector
       (loc/tr :op.oppo/reactivate)))

(defmethod te/timeline-entry-view :op.oppo/reactivate [{entry :entry}]
  [default/timeline-item-view entry title-generator default/body-generator])
